import React, { useState, useEffect } from "react";

const JSONToHTMLTable = (props: any) => {
  const { data } = props;
  return (
    <table className="table table-bordered table-condensed table-sm m-0 p-0">
      <tbody>
        {Object.keys(data).map((k) => (
          <tr key={k}>
            {!Array.isArray(data) && (
              <td className="font-weight-bold bg-light key-cell" width="20%">
                {k.replace(/_/g, " ")}
              </td>
            )}
            {(() => {
              if (data[k] && typeof data[k] === "object") {
                return (
                  <td width="80%" className="value-cell bg-white">
                    <JSONToHTMLTable data={data[k]} />
                  </td>
                );
              }
              return <td width="80%" className="value-cell bg-white">{data[k]}</td>;
            })()}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const JSONToHtmlViewer = (props: any) => {
  const [jsonData, setJsonData]: any = useState({});

  useEffect(() => {
    setJsonData(props.jsonData);
  }, [props]);

  if (!jsonData) {
    return null;
  }

  return (
    <div className="json-to-html-viewer">
      <JSONToHTMLTable data={jsonData} />
    </div>
  );
};

export default JSONToHtmlViewer;
